















































































































import {Component, Ref, Vue, Watch} from "vue-property-decorator";
import {Action} from "vuex-class";
import {SelectWings} from "wings-ui-components";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {BlacklistItem} from "@/store/settings/blacklists/types";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: {SelectWings}})
export default class BlackList extends Vue{
  @Ref('validator') validator:any;

  @Action("getPartners") actionGetPartners: any;
  @Action("getPartnerUsers") actionGetPartnerUsers: any;
  @Action("getBlackListItem") actionGetItem: any;
  @Action("saveBlackList") actionSave: any;
  @Action("deleteBlackList") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private item: BlacklistItem = this.defaultItem();
  private itemSaved: BlacklistItem = this.defaultItem();
  private contacts_uniqueness: boolean = true;
  private logObject: ActionLog = {};
  partnersList: any = []
  partnerUsersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  defaultItem(): BlacklistItem {
    return {check_duplicates_policy : 3}
  }

  async getPartnerUsersList(filter: any) {
    if (!this.item.partner_id) return
    const items = await this.actionGetPartnerUsers({partner_id: this.item.partner_id, ...filter});
    this.partnerUsersList = (filter?.page_number > 1) ? this.partnerUsersList.concat(items) : items
  }

  async created() {
    if (this.$route.params.id) {
      try{
        const object_name = this.$route.query.name as string;
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_name: object_name,
          object_type: "Blacklist"
        }
        const data = await this.actionGetItem(this.$route.params.id)
        await this.actionLog(this.logObject);
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
        this.contacts_uniqueness = Boolean(data.check_duplicates_policy);
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
      }
      this.partnersList = await this.actionGetPartners({id: this.item.partner_id});
      this.partnerUsersList = await this.actionGetPartnerUsers({id: this.item.partner_user_id});
    }
  }

  back():void{
    this.$router.push(`/settings/black_lists/`);
  }

  async onSaveItem():Promise<void> {
    let valid:boolean = await this.validator.validate();
    if (valid) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: 'success',
          object_type: "Blacklist",
          object_name: this.item.name,
          addititional_info: getTranslatedParams(this.item)
        }
        await this.actionSave(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        throw error;
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
    }
  }

  async onDeleteItem():Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: 'success',
          object_type: "Blacklist",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  @Watch('item.partner_id')
  onPartnerChanged(val?: number, oldVal?: number) {
    if (oldVal && val !== oldVal) {
      this.item.partner_user_id = undefined;
    }
  }
  @Watch('contacts_uniqueness', {immediate: false})
  onContactsUniquenessChanged(val?: boolean) {
    if (!val) this.item.check_duplicates_policy = 0;
    else this.item.check_duplicates_policy = 3;
  }
}
